import { connect } from 'react-redux';

import CalendarEventAdminEditScreen from '../components/CalendarEventAdminEditScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    partnershipActiveId: storage.get(findStorageType(), 'partnershipId'),
    isLoading: state.calendarEventsAdmin.get('isLoading'),
    success: state.calendarEventsAdmin.getIn(['form', 'success']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const CalendarEventAdminEditScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CalendarEventAdminEditScreen);

export default CalendarEventAdminEditScreenContainer;
